import { Form, FormInstance, Input, InputNumber, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import useGetRequest from "../../hooks/useGetRequest";
import { Cashbox } from "../../types/cashbox.type";
import { Order } from "../../types/order.type";
import { useExchangeRate } from "../../contexts/exchangeRate.context";
import { Machine } from "../../types/machine.type";

const { Option } = Select;

interface CreateForkProps {
    title: string;
    open: boolean;
    form: FormInstance;
    confirmLoading: boolean;
    onCancel: () => void;
    onOk: () => void;
    onFinish: (values: {
        orderId: string;
        amount: number;
        exchangeRate: number;
        cashboxId: string;
        machineId: string;
        description: string;
    }) => void;
    order: Order;
}

const CreateFork: React.FC<CreateForkProps> = ({
    title,
    open,
    form,
    confirmLoading,
    onCancel,
    onOk,
    onFinish,
    order,
}) => {
    const [amount, setAmount] = useState<number | null>(null);
    const [selectedCashbox, setSelectedCashbox] = useState<Cashbox | null>(null);
    const { exchangeRate } = useExchangeRate();
    const { data: cashboxesList, loading } = useGetRequest("/cashbox/list");
    const { data: machineList, loading: machineListLoading } =
        useGetRequest("/machine/list");
    const handleCashboxChange = (value: string) => {
        const cashbox = cashboxesList?.find((c: Cashbox) => c._id === value);
        setSelectedCashbox(cashbox || null);
    };

    useEffect(() => {
        if (exchangeRate) {
            form.setFieldsValue({ exchangeRate });
        }
    }, [exchangeRate, form]);

    return (
        <Modal
            title={title}
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            confirmLoading={confirmLoading}
        >
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item
                    name="cashboxId"
                    label="Касса"
                    rules={[{ required: true, message: "Выберите кассу" }]}
                >
                    <Select
                        placeholder="Выберите кассу"
                        loading={loading}
                        onChange={handleCashboxChange}
                        showSearch
                        filterOption={(input, option) => {
                            const optionText = option?.label || option?.children;
                            return String(optionText).toLowerCase().includes(input.toLowerCase());
                        }}
                        optionFilterProp="children"
                    >
                        {cashboxesList?.map((cashbox: Cashbox) => (
                            <Option key={cashbox._id} value={cashbox._id}>
                                Имя: {cashbox.name} | Валюта: {cashbox.currency}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="amount"
                    label="Сумма"
                    rules={[{ required: true, message: "Введите сумму" }]}
                >
                    <InputNumber
                        value={amount}
                        onChange={(value) => setAmount(value)}
                        min={0}
                    />
                </Form.Item>


                <Form.Item name="exchangeRate" label="Курс" hidden={true}>
                    <InputNumber value={exchangeRate} min={0} />
                </Form.Item>

                <Form.Item name="machineId" label="Станок" rules={[{ required: true, message: "Выберите станок" }]}>
                    <Select 
                        placeholder="Выберите станок" 
                        allowClear 
                        loading={machineListLoading}
                        showSearch
                        filterOption={(input, option) => {
                            const optionText = option?.label || option?.children;
                            return String(optionText).toLowerCase().includes(input.toLowerCase());
                        }}
                        optionFilterProp="children"
                    >
                        {machineList?.map((machine: Partial<Machine>) => (
                            <Option key={machine._id} value={machine._id}>
                                {machine.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Описание"
                    rules={[{ required: true, message: "Введите описание" }]}
                >
                    <Input.TextArea />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreateFork;
